import ScrollMagic from "scrollmagic"

var controller = new ScrollMagic.Controller();

//スクロールアニメーション
// class ScrollFade {
//     constructor() {
//         this.ANIMATION_CLASS = 'is-fire';

//         let $section = document.querySelectorAll('.scroll:not(.is-fire)');
//         if($section.length === null) {
//             return;
//         }
//         let controller = new ScrollMagic.Controller();
//         for(let i = 0; i < $section.length; i++) {
//             let scene = new ScrollMagic.Scene({
//                 triggerElement: $section[i],
//                 triggerHook: 'onEnter',
//                 reverse: false,
//                 offset: 200
//             })
//                 .addTo(controller);
//             scene.on('enter', ()=>{
//                 $section[i].classList.add(this.ANIMATION_CLASS);
//             });
//             scene.on('end', ()=>{
//                 scene.destroy(true);
//             });
//         }
//     }
//   }

//   new ScrollFade();

// "use strict";

// function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

// function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// var ScrollFade = /*#__PURE__*/_createClass(function ScrollFade() {
//   var _this = this;

//   _classCallCheck(this, ScrollFade);

//   this.ANIMATION_CLASS = 'is-fire';
//   var $section = document.querySelectorAll('.scroll:not(.is-fire)');

//   if ($section.length === null) {
//     return;
//   }

//   var controller = new ScrollMagic.Controller();

//   var _loop = function _loop(i) {
//     var scene = new ScrollMagic.Scene({
//       triggerElement: $section[i],
//       triggerHook: 'onEnter',
//       reverse: false,
//       offset: 200
//     }).addTo(controller);
//     scene.on('enter', function () {
//       $section[i].classList.add(_this.ANIMATION_CLASS);
//     });
//     scene.on('end', function () {
//       scene.destroy(true);
//     });
//   };

//   for (var i = 0; i < $section.length; i++) {
//     _loop(i);
//   }
// });

// new ScrollFade();

//header
const pathname= location.pathname;
if(pathname === "/"){
    new ScrollMagic.Scene({
        triggerElement: "#slider",
        triggerHook: 'onLeave',
        // offset: 100
    })
    .setClassToggle("#header", "is-fire") // add class toggle
    .addTo(controller);
}

// go2top
new ScrollMagic.Scene({
    triggerElement: ".homeslide",
    triggerHook: 'onLeave',
    // offset: 100
})
.setClassToggle("#go2top", "is-fire") // add class toggle
.addTo(controller);

const main =  document.getElementById('main');
// const mainH = main.clientHeight;

if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
    window.addEventListener('scroll', () => {
        const elem = document.getElementById('go2top');
        const docHeight = document.body.clientHeight;
        const scrollCount = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollPos = document.documentElement.clientHeight + scrollCount;
        const footerHeight = document.querySelector('.footer').clientHeight;
        if (docHeight - scrollPos <= footerHeight) {
          elem.style.position = 'absolute';
          elem.style.bottom = -20 + 'px';
        } else {
          elem.style.position = 'fixed';
          elem.style.bottom = 8 + 'px';
        }
   });
}
